module.exports = __webpack_public_path__ + "img/research-office-trends-single.4e74a625.png";